import { Action, createReducer, on } from '@ngrx/store';
import { IProductSolution } from '../models/product-solutions.model';
import * as fromActions from '../actions';

export const getSelectedProductSolutionFeatureKey = 'getSelectedProductSolution';

export interface State {
  loaded: boolean;
  error?: Error | any;
  getSelectedProductSolution: IProductSolution;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  getSelectedProductSolution: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromActions.loadGetSelectedProductSolution,

    state => state
  ),
  on(fromActions.loadGetSelectedProductSolutionSuccess, (state, action) => ({
    ...state,
    getSelectedProductSolution: action.response,
    loaded: true
  })),

  on(fromActions.loadGetSelectedProductSolutionFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(fromActions.clearSelectedProductSolution, (state, action) => ({
    ...state,
    getSelectedProductSolution: undefined,
    loaded: false
  }))
);

export const getSelectedProductSolution = (state: State) => state.getSelectedProductSolution;
export const getSelectedProductSolutionLoaded = (state: State) => state.loaded;
export const getSelectedProductSolutionError = (state: State) => state.error;
